import { NgModule } from '@angular/core';
import { LyDeepComponent } from './deep';
import { LyShadowService } from './shadow.service';
export { LyShadowService } from './shadow.service';
export { LyDeepComponent } from './deep';
var LyShadowModule = (function () {
    function LyShadowModule() {
    }
    /**
     * @return {?}
     */
    LyShadowModule.forRoot = function () {
        return {
            ngModule: LyShadowModule,
            providers: [LyShadowService],
        };
    };
    return LyShadowModule;
}());
export { LyShadowModule };
LyShadowModule.decorators = [
    { type: NgModule, args: [{
                declarations: [LyDeepComponent],
                exports: [LyDeepComponent],
                providers: [LyShadowService]
            },] },
];
/**
 * @nocollapse
 */
LyShadowModule.ctorParameters = function () { return []; };
function LyShadowModule_tsickle_Closure_declarations() {
    /** @type {?} */
    LyShadowModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyShadowModule.ctorParameters;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/shadow/index.js
// module id = 1384
// module chunks = 31